
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import styles from './ComplaintDetail.module.css';

export default function ComplaintDetailSkeleton() {
  return (
    <div className={styles.page}>
      {/* Back Link Skeleton */}
      <Skeleton width={150} height={20} style={{ marginBottom: 16 }} />

      {/* Header Skeleton */}
      <div className={styles.detailHeader}>
        <Skeleton width={300} height={32} />
      </div>

      {/* Detail Grid Skeleton */}
      <div className={styles.detailGrid}>
        {/* Card 1 */}
        <div className={styles.detailCard}>
          <Skeleton width={150} height={14} style={{ marginBottom: 14 }} />
          <div className={styles.fieldRow}>
            <div className={styles.field}>
              <Skeleton width={80} height={12} style={{ marginBottom: 4 }} />
              <Skeleton width="100%" height={20} />
            </div>
            <div className={styles.field}>
              <Skeleton width={80} height={12} style={{ marginBottom: 4 }} />
              <Skeleton width="100%" height={20} />
            </div>
          </div>
          <div className={styles.fieldRow}>
            <div className={styles.field}>
              <Skeleton width={80} height={12} style={{ marginBottom: 4 }} />
              <Skeleton width="100%" height={20} />
            </div>
            <div className={styles.field}>
              <Skeleton width={80} height={12} style={{ marginBottom: 4 }} />
              <Skeleton width="100%" height={20} />
            </div>
          </div>
        </div>

        {/* Card 2 */}
        <div className={styles.detailCard}>
          <Skeleton width={150} height={14} style={{ marginBottom: 14 }} />
          <div className={styles.fieldRow}>
            <div className={styles.field}>
              <Skeleton width={80} height={12} style={{ marginBottom: 4 }} />
              <Skeleton width="100%" height={20} />
            </div>
          </div>
          <div className={styles.fieldRow}>
            <div className={styles.field}>
              <Skeleton width={80} height={12} style={{ marginBottom: 4 }} />
              <Skeleton width="100%" height={20} />
            </div>
            <div className={styles.field}>
              <Skeleton width={80} height={12} style={{ marginBottom: 4 }} />
              <Skeleton width="100%" height={20} />
            </div>
          </div>
        </div>

        {/* Narrative Card */}
        <div className={`${styles.detailCard} ${styles.detailFull}`}>
          <Skeleton width={180} height={14} style={{ marginBottom: 14 }} />
          <Skeleton count={3} height={16} style={{ marginBottom: 6 }} />
        </div>

        {/* Response Card */}
        <div className={styles.detailCard}>
          <Skeleton width={180} height={14} style={{ marginBottom: 14 }} />
          <Skeleton count={2} height={16} style={{ marginBottom: 6 }} />
        </div>

        {/* Resolution Card */}
        <div className={styles.detailCard}>
          <Skeleton width={180} height={14} style={{ marginBottom: 14 }} />
          <Skeleton count={2} height={16} style={{ marginBottom: 6 }} />
        </div>

      </div>
    </div>
  );
}
